import { AdSlotContainer } from './ad-slot-container';
import { LinkingTypeEnum, PublicRecommendationItemDto } from '../dto/recs.dto';

export class AdSlotContainerItem {
  private readonly id?: string;
  private readonly title?: string;
  private readonly subtitle?: PublicRecommendationItemDto['subtitle'] = null;
  private readonly campaignId?: string;
  private readonly publicationId?: string;
  private readonly url?: string;
  private readonly clickUrl?: string;
  private readonly impressionUrl?: string;
  private readonly linkingType?: LinkingTypeEnum;
  private readonly authors?: string | null = null;
  private readonly publicationName?: string | null = null;
  private readonly publicationAbbreviatedName?: string | null = null;
  private readonly publicationDate?: string | null = null;
  private readonly creativeType?: PublicRecommendationItemDto['creativeType'];
  private readonly creative?: PublicRecommendationItemDto['creative'];
  private adSlotContainer?: AdSlotContainer;

  public getId (): string {
    if (typeof this.id === 'undefined') {
      throw new Error(`Attempt to access "id" of ${this.constructor.name} before initialization`);
    }

    return this.id;
  }

  public getTitle (): string | null {
    return this.title ?? null;
  }

  public getSubtitle (): PublicRecommendationItemDto['subtitle'] {
    return this.subtitle ?? null;
  }

  public getUrl (): string | null {
    return this.url ?? null;
  }

  public getClickUrl (): string | null {
    return this.clickUrl ?? null;
  }

  public getImpressionUrl (): string | null {
    return this.impressionUrl ?? null;
  }

  public getCampaignId (): string | null {
    return this.campaignId ?? null;
  }

  public getPublicationId (): string | null {
    return this.publicationId ?? null;
  }

  public getAuthors (): string | null {
    return this.authors ?? null;
  }

  public getPublicationName (): string | null {
    return this.publicationName ?? null;
  }

  public getPublicationAbbreviatedName (): string | null {
    return this.publicationAbbreviatedName ?? null;
  }

  public getPublicationDate (): string | null {
    return this.publicationDate ?? null;
  }

  public getLinkingType (): LinkingTypeEnum | null {
    return this.linkingType ?? null;
  }

  public getCreativeType (): PublicRecommendationItemDto['creativeType'] | null {
    return this.creativeType ?? null
  }

  public getCreative (): PublicRecommendationItemDto['creative'] | null {
    return this.creative ?? null;
  }

  public getAdSlotContainer (): AdSlotContainer | null {
    return this.adSlotContainer ?? null;
  }

  public setAdSlotContainer (adSlot?: AdSlotContainer): this {
    this.adSlotContainer = adSlot;
    return this;
  }
}
